module.exports = __webpack_public_path__ + "static/media/resume.5c8a2c6c.png";